/**
 * An unknown /clinic path. It sits outside the second-factor gate, so it never asks anyone to sign
 * in just to learn that the address is wrong.
 */
import * as stylex from "@stylexjs/stylex";
import { useEffect } from "react";
import "@lattice/tokens/color.stylex";
import { color } from "@lattice/tokens/color.stylex";
import "@lattice/tokens/space.stylex";
import { space } from "@lattice/tokens/space.stylex";
import "@lattice/tokens/text.stylex";
import { text } from "@lattice/tokens/text.stylex";
import { LinkButton } from "@lattice/ui/LinkButton";
import type { Place } from "../NotFound.tsx";
import { AskedAddress, FocusedTitle, Places, useNoIndex } from "../NotFound.tsx";
import { ClinicShell } from "./Shell.tsx";
const CLINIC_PLACES: readonly Place[] = [{
  href: "/clinic",
  name: "Clinic home",
  hint: "Your patients and what is waiting"
}, {
  href: "/clinic/patients",
  name: "Patients",
  hint: "Everyone linked to your clinic"
}, {
  href: "/practitioners",
  name: "Practitioner sign-in",
  hint: "Sign in with your clinic account"
}, {
  href: "/support",
  name: "Support",
  hint: "Questions and reports"
}];
const styles = {
  heading: {
    kogj98: "x1ghz6dp",
    kGuDYH: "x1u29x3t",
    k63SB2: "xqu410z",
    kQqvRs: "x1ntj4s9",
    kb6lSQ: "x1d3j7mx",
    kLWn49: "x1e5flnj",
    kN2L0X: "x1w2vvpw",
    $$css: true
  }
};
export function ClinicNotFound() {
  useNoIndex();
  useEffect(() => {
    document.title = "Page not found · Lattice Clinic";
  }, []);
  return <ClinicShell>
      <div className="x78zum5 xdt5ytf x626il7">
        <FocusedTitle styled={[styles.heading]}>We can't find that clinic page</FocusedTitle>
        <p className="x1ghz6dp x1jty25b x1fzhlzt">
          The address may be mistyped, or the page may have moved. Nothing in your clinic was
          changed.
        </p>
        <AskedAddress />
        <Places label="Places you may have meant" places={CLINIC_PLACES} />
        <div className="x78zum5 x1a02dak x626il7 x1rtxbgk">
          <LinkButton href="/clinic" corners="rounded">
            Go to the clinic home
          </LinkButton>
          <LinkButton href="/support" tone="quiet" corners="rounded">
            Contact support
          </LinkButton>
        </div>
      </div>
    </ClinicShell>;
}